import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { Breadcrumb, Table, Typography } from "antd";


import Spacer from "components/Spacer";
import Container from "components/Container";
import { useSingle } from "modules/mandatoryRequirement/hooks";
import { renderTextWithLink } from "lib/renderTextWithLink";

const titles = {
    info1: "mandatory-requirements-table-info1",
    info2: "mandatory-requirements-table-info2",
    info3: "mandatory-requirements-table-info4",
    info4: "mandatory-requirements-table-info3",
    info5: "mandatory-requirements-table-info5",
    info6: "mandatory-requirements-table-info6",
    info7: "mandatory-requirements-table-info7",
    info8: "mandatory-requirements-table-info8",
    info9: "mandatory-requirements-table-info9",
    info10: "mandatory-requirements-table-info10",
    info11: "mandatory-requirements-table-info11",
    info12: "mandatory-requirements-table-info12",
}

const MandatoryRequirementView = () => {
    const { t, i18n } = useTranslation();
    const { id } = useParams();

    const { item } = useSingle({ id });

    return (
        <Container>
            <Spacer size={35} />

            <Breadcrumb separator=">">
                <Breadcrumb.Item href="/">{t('home')}</Breadcrumb.Item>
                <Breadcrumb.Item href="/mandatory-requirement/register">{t('mandatory-requirements')}</Breadcrumb.Item>
                <Breadcrumb.Item href="/mandatory-requirement">
                    {t("mandatory-requirements")}
                </Breadcrumb.Item>
                <Breadcrumb.Item>{t('mandatory-requirement')} - {item.id}</Breadcrumb.Item>
            </Breadcrumb>

            <Spacer size={32} />
            <Typography.Title style={{ textAlign: "center" }}>{t("mandatory-requirement-passport")}</Typography.Title>
            <Spacer size={32} />

            <Table
                rowKey="title"
                columns={[
                    {
                        render: (text, record, index) => index + 1,
                        width: "4%"
                    },
                    {
                        key: "title",
                        dataIndex: "title",
                        render: (text, record) => <strong>{t(record.title)}</strong>,
                    },
                    {
                        key: "info",
                        dataIndex: ["info", i18n.language],
                        width: "50%",
                        render: (value) => (<div style={{ wordBreak: "break-all" }} dangerouslySetInnerHTML={{ __html: renderTextWithLink(value) }} />)
                    },
                ]}
                dataSource={Object.keys(item).filter(k => k.startsWith("info")).map((key) => {
                    return ({ title: titles[key], info: item[key] })
                })}
                pagination={false}
                scroll={{ x: 1400 }}
            />
            <Spacer size={48} />
        </Container>
    );
};

export default MandatoryRequirementView;
